import { Injectable } from '@angular/core';
import { Achievement } from '../models/achievement.model';
import { ACHIEVEMENTS } from '../data/achievements';
import { Advantage } from '../models/advantage.model';
import { ADVANTAGES } from '../data/advantages';
import { Mentor } from '../models/mentor.model';
import { MENTORS } from '../data/mentors';
import { Partner } from '../models/partner.model';
import { PARTNERS } from '../data/partners';
import { MentorFQA } from '../models/mentor-fqa.model';
import { MENTOR_FQA } from '../data/mentor-fqas';
import { Case } from '../models/case.model';
import { CASES } from '../data/cases';
import { Education } from '../models/education.model';
import { EDUCATIONS } from '../data/educations';
import { Career } from '../models/career.model';
import { CAREERS } from '../data/careers';

@Injectable()
export class DataService {

  achievements: Achievement[] = ACHIEVEMENTS;
  advantages: Advantage[] = ADVANTAGES;
  mentors: Mentor[] = MENTORS;
  partners: Partner[] = PARTNERS;
  mentorFQAs: MentorFQA[] = MENTOR_FQA;
  cases: Case[] = CASES;
  educations: Education[] = EDUCATIONS;
  careers: Career[] = CAREERS;
  constructor() { }

  // getAchievements(): Achievement[] {
  //   return this.achievements;
  // }
  //
  // getAdvantages(): Advantage[] {
  //   return this.advantages;
  // }
  //
  // getMentors(): Mentor[] {
  //   // console.log(this.mentors.length);
  //   return this.mentors;
  // }

  getPartner(): Partner[] {
    return this.partners;
  }

  // getMentorFQAs(): MentorFQA[] {
  //   // console.log(this.mentors.length);
  //   return this.mentorFQAs;
  // }
  //
  // getCases(): Case[] {
  //   return this.cases;
  // }

  getEducation(category: any) {
    return this.educations.find( (education) => education.category == category);
  }

  getCareer(category: any) {
    return this.careers.find( (career) => career.category == category);
  }
}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/services/data.service.ts